//React components 
import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom';
//Components 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ErrorAlert from '../Alerts/ErrorAlert';
import { Container } from 'react-bootstrap';
import { RenderIf } from '../utils/RenderIf';
import Modal from 'react-bootstrap/Modal'

import refund from '../img/icons/refund.png'
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';

//PDF
import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import DocPdf from '../Pdf/DocPdf';
import FullScreen from '../FullScreen';
import Swal from 'sweetalert2';
import { Button } from 'react-bootstrap';
import { formatVoucherString } from '../../utils/FormatVoucherString';
//utils
import { buildCloudinaryImageUrl } from '../../utils/CloudinaryImageUrl';
//IMG
import img_default from "../../assets/img/default.png";


const RecoveryOrderApproved = ({ recoveryOrderApproved, setRecoveryOrderApproved, registernewOrder, orderData, setOrderToRecovery }) => {
    const [modalShowVoucher, setmodalShowVoucher] = useState(false)
    const [voucher, setvoucher] = useState("")
    //We charge the items of the order 
    const orderItems = () => {
        let items = orderData.Orden.map((product) => (


            <>{product.type == "separator" ? <><div className="d-flex text-muted pt-3 px-xs-2" key={product.group_id}>
                <div className="pb-3 mb-0  lh-sm  w-100 d-flex border rounded border-primary border-2  mt-3 position-relative bg-white">
                    <div className="d-flex justify-content-between ">
                        {/* Name */}
                        <span className="text-dark fw-bold"><i class="uil uil-arrow-from-top">{product.name}</i></span>

                    </div>

                </div>
            </div></> : <>
                <div className="d-flex text-muted pt-3 px-xs-2" key={product.group_id}>
                    <img className="bd-placeholder-img flex-shrink-0 me-2 rounded" src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || img_default} width="42" height="42" />
                    <div className="pb-3 mb-0  lh-sm  w-100">
                        <div className="d-flex justify-content-between ">
                            {/* Name */}
                            <span className="text-dark fw-bold">{product.name}</span>
                            {/* Cantidad/ Quantity*/}
                            <div>
                                <span className='px-3'>x {product.amount} </span>
                                <label className="fw-bold" translate='no'>$ {product.price}</label>
                            </div>

                        </div>
                        {/** Segment items */}
                        <>
                            <div className="d-flex justify-content-between">
                                {/* Name */}

                                {/* Cantidad/ Quantity*/}
                                <div >
                                    {/** We check the type of modal and we return the input discount field depending of it */}


                                </div>
                            </div>
                            {product.segments.map((segments) => (
                                <div className="d-flex justify-content-between" key={segments._id}>
                                    {/* item name */}
                                    <span className="">{segments.item.name}</span>
                                </div>
                            ))}

                            <div>
                                <div>
                                    <small className='text-primary p-1' >
                                        Entrega: {product.delivery_type}
                                    </small>
                                </div>
                                <div>
                                    <RenderIf isTrue={product.note != ""}>
                                        <small className='text-danger p-1' >
                                            Nota: {product.note}
                                        </small>
                                    </RenderIf>
                                </div>
                            </div>

                        </>
                    </div>
                </div></>}</>
        ));
        return <>{items}</>
    }

    //Template card Group of setGroup
    const cardGroup = (product) => {
        return (

            <>

                {product.type == "separator" ? <>
                    <div className="card-group">
                        <div className="card">
                            <div className='d-flex justify-constent- between'>

                                <div className="card-body">
                                    <h5 className="card-title"><i class="uil uil-arrow-from-top">{product.name}</i></h5>

                                </div>
                            </div>
                        </div>
                    </div></> : <>
                    <div className="card-group">
                        <div className="card">
                            <div className='d-flex justify-constent- between'>
                                <img src={buildCloudinaryImageUrl({ url: product.img, width: 300, quality: "auto", type: "image" }) || img_default} className='m-2' alt="..." width="50" height="50" />
                                <div className="card-body">
                                    <h5 className="card-title">{product.name}</h5>
                                    <details close >
                                        <summary className=''>
                                            <span className='badge bg-light text-dark summary-text-pos  fw-bold border rounded-4  text-wrap '>
                                                <i className="uil uil-info-circle  px-1 "></i>  Detalles
                                            </span>
                                        </summary>
                                        {product.segments.map(item => (
                                            <span className="badge bg-light text-dark  summary-text-pos m-2 border rounded-4 my-1 text-wrap ">

                                                <span className='text-muted m-0 p-0'>{item.name}:</span>
                                                <br />
                                                <strong>
                                                    <span className='me-2'>{item.item.name} </span>
                                                    {parseFloat(item.item.price).toFixed(2)}
                                                </strong>
                                            </span>
                                        ))}
                                    </details>
                                </div>
                            </div>
                        </div>
                    </div></>}

            </>
        )
    }

    //Function to forget the order
    const forgetOrder = () => {
        const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
                confirmButton: 'btn btn-success',
                cancelButton: 'btn btn-danger'
            },
            buttonsStyling: false
        })


        swalWithBootstrapButtons.fire({
            title: "Quieres olvidar la orden anterior?",
            text: "Si la olvidas no podras recuperarla luego y se eliminara de forma permanente",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Si, Olvidar!',
            cancelButtonText: 'No, olvidar la orden!',
            reverseButtons: true
        }).then((result) => {
            if (result.isConfirmed) {
                swalWithBootstrapButtons.fire(
                    'Orden Olvidada',
                    '',
                    'success'
                )
                setRecoveryOrderApproved(false);
                setOrderToRecovery(null)
                localStorage.removeItem('OrderDetails')

            } else if (
                /* Read more about handling dismissals below */
                result.dismiss === Swal.DismissReason.cancel
            ) {
                swalWithBootstrapButtons.fire(
                    'Debes registrar la orden',
                    '',
                    'info'
                )

            }
        })
    }

    return (<>
        {/* Modal */}
        {recoveryOrderApproved && (
            <div className="modal-backdrop-custom">
                <div
                    className="bg-white rounded-4 shadow-lg modal-content-custom"
                    style={{ maxWidth: '900px', width: '100%' }}
                    onClick={(e) => e.stopPropagation()}
                >

                    {/* Header */}
                    <div className="header-gradient-preacounts text-white p-4 position-relative rounded-top-4">
                        <button className="btn-close-custom position-absolute top-0 end-0 m-3 p-2 rounded-circle " >
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                        <div className="flex-grow-1">
                            <h2 className="h3 fw-bold mb-2">
                                Recuperacion de orden aprobada
                            </h2>
                            <p className="mb-0 small opacity-90 d-flex align-items-center gap-1">
                                <i className="uil uil-info-circle me-1"></i>
                                Por favor, registre esta orden.</p>
                        </div>
                    </div>
                    {/* Content */}
                    <div className="p-lg-4 p-1 p-md-2 item2 list-framer-precuentas border ">
                        <div className='row'>

                            <div className="col-lg-12 col-md-12 col-12 mb-3">
                                <div className="head-section-sp mt-2 m-3">
                                    <div className="">
                                        <div className="mt-1 mb-3">


                                            <div className="d-flex justify-content-between align-items-center mb-3 ">
                                                <div className='header-invoice'>

                                                    <div>
                                                        <h5 className='p-2'>
                                                            <span className="text-success"> {orderData.tipoOrden} </span>

                                                        </h5>
                                                    </div>
                                                </div>
                                                <h5>
                                                    <span className="text-success">Orden: </span>
                                                    <span className="text-secondary">Cobro exitoso</span>
                                                </h5>
                                            </div>



                                            <div>
                                                <span className="text-nowrap text-primary h6 d-block mb-2">
                                                    <i class="uil uil-user-circle"></i>&nbsp;
                                                    Cliente: {orderData.client_name}
                                                </span>
                                                <span className="text-nowrap text-secondary h6 d-block">
                                                    <i class="uil uil-list-ol"></i>
                                                    Cantidad de productos: {(orderData.Orden.length + orderData.combos.length)}
                                                </span>
                                                <span className="text-nowrap text-secondary h6 d-block">
                                                    <i class="uil uil-list-ol"></i>
                                                    Metodo de pago: {orderData.paymenthod_info?.payment}
                                                </span>

                                                {/**Voucher button */}
                                                {orderData?.EMVStreamResponse?.voucher &&
                                                    <button class="btn bg-primary-subtle rounded-2 border-primary text-primary fw-bold"
                                                        onClick={() => (setvoucher(formatVoucherString(orderData?.EMVStreamResponse?.voucher)), setmodalShowVoucher(true))} title="Actualizar Lista">
                                                        <i className="uil uil-receipt-alt "></i>
                                                        Voucher de transacción
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                    </div>

                                    <div className=' d-flex justify-content-between text-secondary opacity-75'>
                                        <div> Productos </div>
                                        <div> Precio </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12 col-lg-12 order-md-last">
                                            {/* Item cards */}
                                            {orderItems()}

                                            {/**Total details */}
                                            <div className="d-flex text-muted pt-3">
                                                <div className="pb-3 mb-0 small lh-sm border-top w-100">

                                                    <div className="d-flex justify-content-end mt-3">
                                                        <span className="text-gray-dark fw-light h6"> Descuento: </span>
                                                        <span className='text-danger fw-light h6'>
                                                            <span className='px-2 ' translate='no'>- $</span>
                                                            {orderData.Descuento}
                                                        </span>
                                                    </div>

                                                    {/** We render the totals if the order is type permanent */}

                                                    <div className="d-flex justify-content-end mt-3">
                                                        <span className="text-gray-dark fw-light h6"> Subtotal: </span>
                                                        <span className='text-black fw-light h6'>
                                                            <span className='px-2 ' translate='no'>$</span>
                                                            {console.log("orderData: ", orderData)}
                                                            {orderData.subtotal}
                                                        </span>
                                                    </div>
                                                    {orderData.taxes.map((tax) => (
                                                        <>
                                                            {parseFloat(tax.total).toFixed(3) > 0 ?
                                                                <div className="d-flex justify-content-end mt-3">
                                                                    <span className="text-gray-dark fw-light h6"> Impuesto {tax.tax}: </span>
                                                                    <span className='text-black fw-light h6'>
                                                                        <span className='px-2 ' translate='no'>$</span>
                                                                        {tax.total}
                                                                    </span>
                                                                </div> : <></>}
                                                        </>
                                                    ))}
                                                    <div className="d-flex justify-content-end mt-3 ">
                                                        <strong className="text-black h5"> Total: </strong>
                                                        <span className='text-black fw-bold h5'>
                                                            <span className='px-2 ' translate='no'>$ </span>
                                                            {orderData.Total}
                                                        </span>
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <div className=' d-block mt-lg-1 mt-0 '>

                        <div className='d-flex justify-content-between m-3'>
                            <button className='btn btn-danger btn-lg' onClick={() => forgetOrder()}> Cerrar </button>
                            <button className='btn btn-lg bg-success-subtle
              bg-brand-smartpay
               text-success fw-bold border-0  ms-2'
                                onClick={() => (registernewOrder(orderData), setRecoveryOrderApproved(false))} >
                                <span className='text-white'>Registrar orden</span>
                            </button>
                        </div>
                    </div>


                </div>
            </div >

        )
        }

        <Modal
            show={modalShowVoucher}
            onHide={() => setmodalShowVoucher(false)}
            centered>
            <Modal.Header>
                Voucher de transaccion
            </Modal.Header>
            <Modal.Body>
                <div>
                    <pre>{voucher}</pre>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => (setmodalShowVoucher(false))}>Cerrar</Button>
            </Modal.Footer>
        </Modal>

    </>);
}

export default RecoveryOrderApproved;